<tt-page class="col-xs-12 col-md-4 sp-0">
    <tt-card>
        <tt-button-goto ttText="custactcustomers_new" ttGoto="custactcustomer" [ttGotoParms]="{ custact_no: argValue, custact_customer_keyno: '0' }" ttIcon="far fa-plus"></tt-button-goto>
    </tt-card>

    <tt-list [ttData]="itemsListCustomers"></tt-list>
</tt-page>
